import { BroadcastChannel as BCPolyfill } from 'broadcast-channel';
import { isDefined } from '@upstart/harmony/lib/legos/utils/tsutils';

let timeoutHandle: NodeJS.Timeout | undefined;
let callback: () => void;

// Try to use native BroadcastChannel if exists, or use polyfill for old browsers
const BC = window.BroadcastChannel ?? BCPolyfill;

// Creates a channel where all tabs will communicate on Session timeout updates
const channel = new BC('uar/launchpad-session-timeout');

// This function enables us to configure the setTimeout callback to dispatch a React App action
export function registerSessionTimeoutCallback(newCallback: () => void) {
  callback = newCallback;
}

// Resets/updates the current Session timeout
export function updateSessionTimeout(timeoutInSeconds: number) {
  if (callback) {
    if (isDefined(timeoutHandle)) {
      clearTimeout(timeoutHandle);
    }
    // Add 5 seconds so there is no risk of going back to another screen and doing a network request, if the client computer's clock has drifted to be early
    timeoutHandle = setTimeout(() => {
      // Make sure to make this tab not observe message from other tabs
      timeoutHandle = undefined;
      callback();
    }, timeoutInSeconds * 1000 + 5000);
  }
}

// Removes the Session timeout timer altogether because user has imperatively logged out
export function userHasLoggedOut() {
  if (isDefined(timeoutHandle)) {
    clearTimeout(timeoutHandle);
  }
  // Make sure to make this tab not observe message from other tabs
  timeoutHandle = undefined;
}

// Called when we receive X-UAR-Session-Duration in the response headers
export function broadcastNewSessionTimeout(timeoutInSeconds: number) {
  // Update locally first, then broadcast.
  // Reason for this is that even though this browser instance has subscribed to onmessage events,
  // the eventing mechanism does not publish the message on the same window that originated the message
  updateSessionTimeout(timeoutInSeconds);
  channel.postMessage(timeoutInSeconds);
}

// Subscribe to messages from other tabs, so this tabs Session timeout is up-to-date
channel.onmessage = (timeoutInSeconds) => {
  // This browser is not currently in a Session, so we don't listen to the other tabs at all
  if (timeoutHandle === undefined) {
    return;
  }
  updateSessionTimeout(timeoutInSeconds.data);
};
